<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store
            .dispatch("services/getForEdit", this.itemId)
            .then((res) => {
                this.vm = res;
            }).catch(() => { });
    this.$store.dispatch("lookups/getDepartments");

  },
  computed: {
    departments() {
      return  this.$store.state.lookups.departments;
    }
   
  },
    data() {
        return {
            vm: {
                serviceName: null,
                price: null,
                departmentId: null
            },

        };
    },
    methods: {
        confirm() {
            this.$store
                .dispatch("services/edit", { id: this.itemId, payload: this.vm })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },

        back() {

            this.$emit("back");
        },
    },
};
</script>